.toggle {
  position: relative;
  z-index: 1;
  padding-left: 36px;
  line-height: 1;
  font-weight: 700;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  color: #626a6f;

  &:before,
  &:after {
    content: "";
    display: block;
    position: absolute;
  }

  &:before {
    width: 32px;
    height: 18px;
    background: #626a6f;
    border-radius: 30px;
    top: calc(50% - 9px);
    left: 0;
    transition: 0.3s ease color;
  }

  &:after {
    height: 12px;
    width: 12px;
    border-radius: 100%;
    background: white;
    z-index: 5;
    top: calc(50% - 6px);
    left: 0;
    transition: 0.3s ease all;
    transform: translateX(3px);
  }
}

.checkbox {
  &:checked {
    & + .toggle {
      &:before {
        background: #e6006f;
      }

      &:after {
        transform: translateX(16px);
      }
    }
  }

  &:focus {
    outline: none;

    & + .toggle:before {
      outline: auto;
      outline-offset: 2px;
    }
  }
}

.icon {
  width: 26px;
  height: auto;
  margin-right: 3px;
}
